const BodyApp = ({ children }) => {
  return (
    <div className="body-app">
      {children}
    </div>
  );
}

export default BodyApp;